import { render, staticRenderFns } from "./selectInput.vue?vue&type=template&id=2aa8d4ab&scoped=true&"
import script from "./selectInput.vue?vue&type=script&lang=js&"
export * from "./selectInput.vue?vue&type=script&lang=js&"
import style0 from "./selectInput.vue?vue&type=style&index=0&id=2aa8d4ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8d4ab",
  null
  
)

export default component.exports